import { render, staticRenderFns } from "./HeaderFamilia.vue?vue&type=template&id=3423bc72"
import script from "./HeaderFamilia.vue?vue&type=script&lang=js"
export * from "./HeaderFamilia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports